import { c as _c } from "react/compiler-runtime";
import Img from '@/components/elements/Img';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import { useRef } from 'react';
// interface FImageSize {
//   width: number;
//   height: number;
// }
const CarouselSlide = (t0) => {
    const $ = _c(17);
    const { media, index, total, imgAltSuffix } = t0;
    const alt = `${media.caption ? capitalize(media.caption) + " - " : ""}${imgAltSuffix ? imgAltSuffix : ""}`;
    const containerRef = useRef(null);
    let t1;
    if ($[0] !== alt || $[1] !== media.url) {
        t1 = <Img src={media.url} alt={alt} sizes="100vw" className="object-cover w-full h-full"/>;
        $[0] = alt;
        $[1] = media.url;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <div className="gradient absolute inset-0 top-auto h-1/5 bg-gradient-to-t from-black to-transparent opacity-70 lg:h-1/4"/>;
        $[3] = t2;
    }
    else {
        t2 = $[3];
    }
    const t3 = index + 1;
    let t4;
    if ($[4] !== t3) {
        t4 = <span className="text-xl font-semibold">{t3}</span>;
        $[4] = t3;
        $[5] = t4;
    }
    else {
        t4 = $[5];
    }
    let t5;
    if ($[6] !== total) {
        t5 = <span className="font-light mr-4"> / {total}</span>;
        $[6] = total;
        $[7] = t5;
    }
    else {
        t5 = $[7];
    }
    let t6;
    if ($[8] !== media.caption) {
        t6 = <span className="text-xs font-semibold hidden md:block capitalize">
      {media.caption}
    </span>;
        $[8] = media.caption;
        $[9] = t6;
    }
    else {
        t6 = $[9];
    }
    let t7;
    if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
        t7 = <>{t2}<div className="absolute bottom-4 flex flex-row justify-center text-white w-full px-4 lg:bottom-20"><div className="flex flex-row items-center w-full xl:max-w-screen-xl">{t4}{t5}{t6}
        </div>
      </div></>;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    }
    else {
        t7 = $[13];
    }
    let t8;
    if ($[14] !== t1 || $[15] !== t7) {
        t8 = <><div className="relative flex flex-col flex-shrink-0 justify-center items-center flex-grow w-full h-full" ref={containerRef}><div data-carousel-slide={true} className="relative flex-shrink-0 w-full h-full">{t1}{t7}

        </div>
      </div></>;
        $[14] = t1;
        $[15] = t7;
        $[16] = t8;
    }
    else {
        t8 = $[16];
    }
    return t8;
};
export default CarouselSlide;
